



import { Component, Prop } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import LedgerState from '@/models/Accounts/LendingAccounts/Ledgers/LedgerState';

@Component({ name: 'LedgerState' })
export default class extends SaascadaVue {

    @Prop({ required: true })
    state: LedgerState;

    get textColor() {
        let color = "";
        switch (this.state) {
            case LedgerState.Active:
                color = "body-2 success--text";
                break;
            case LedgerState.Closed:
                color = "body-2 error--text";
                break;
        }
        return color;
    }
}
